"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _logic = require("../logic");

var useHandleMoveQuestion = function useHandleMoveQuestion(questionList, reorderQuestions) {
  var handleMoveQuestion = (0, _react.useCallback)(function (item, oldIndex, newIndex) {
    // important to note: index =/= position. Index is the index in the array, position is the position in the entire form.
    // it's also important to point out that it is IMMENSELY easier to test logic when it's not inside a callback/hook. This is
    // a good example of extracting complex logic to the logic.js file so that everything is easier to test.
    var newItemPositions = (0, _logic.reorderItems)(questionList, oldIndex, newIndex, item);
    reorderQuestions(newItemPositions, item.id);
  }, [questionList, reorderQuestions]);
  return handleMoveQuestion;
};

var _default = exports["default"] = useHandleMoveQuestion;